// extracted by mini-css-extract-plugin
export default {"daysCheckbox":"result_daysCheckbox__yJlOU"};